import React, { useEffect, useState } from "react";
import { FloatButton } from "antd";
import { HomeFilled, PictureFilled, VideoCameraFilled } from "@ant-design/icons";

import SceneComponent from "./components/Scene";
import MainMenu from "./components/MainMenu";
import Loader from "./components/Loader";

import Vinyl from "./components/vinyl/Vinyl";
import Hobbies from "./components/tv/Hobbies";
import SkillDisplay from "./components/skills/SkillDisplay";
import Degrees from "./components/diplomas/Degrees";
import Desk from "./components/desk/Desk";
import ScreenWarning from "./components/ScreenWarning";
import StaticMobileScene from "./components/StaticMobileScene";
import StaticScene from "./components/StaticScene";

function App() {
  const [cameras, setCameras] = useState([]);
  const [scene, setScene] = useState('main');
  const [activeCamera, setActiveCamera] = useState(null);
  const [areCamerasLoaded, setAreCamerasLoaded] = useState(false);
  const [trackedObjects, setTrackedObjects] = useState([]);
  const [renderScene, setRenderScene] = useState(true);

  const [showWarning, setShowWarning] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    const checkScreen = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      const isTooSmall = window.innerWidth < 800;

      if (isPortrait || isTooSmall) {
        //setShowWarning(true);
        //setAreCamerasLoaded(false);
        setIsMobile(true);
      } else {
        setShowWarning(false);
        setIsMobile(false);
      }
      
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    if (activeCamera !== null && activeCamera !== process.env.REACT_APP_MAIN_CAMERA && activeCamera !== process.env.REACT_APP_MAIN_CAMERA_MOBILE) {
      setIsFirstLoad(false);
    }
  }, [activeCamera]);

  const handleRenderClick = () => {
    setRenderScene(!renderScene);
    setAreCamerasLoaded(false);
  };

  return (
    <>
      {showWarning ? <ScreenWarning /> : (
        <>
          {renderScene ? (
            <div style={{ width: "100vw", height: "100vh" }}>
              <SceneComponent 
                setTrackedObjects={setTrackedObjects}
                setCameras={setCameras}
                activeCamera={activeCamera}
                setActiveCamera={setActiveCamera}
                setAreCamerasLoaded={setAreCamerasLoaded}
                isMobile={isMobile}
              />
              {areCamerasLoaded ? (
                <>
                  {(activeCamera === cameras[process.env.REACT_APP_TV_CAMERA] || activeCamera === cameras[process.env.REACT_APP_TV_CAMERA_MOBILE]) && trackedObjects && (<Hobbies trackedObjects={trackedObjects} />)}
                  {activeCamera === cameras[process.env.REACT_APP_MAIN_CAMERA] && trackedObjects && ( <MainMenu setActiveCamera={setActiveCamera} cameras={cameras} trackedObjects={trackedObjects} isMobile={isMobile} firstLoad={isFirstLoad} /> )}
                  {(activeCamera === cameras[process.env.REACT_APP_DESK_CAMERA] || activeCamera === cameras[process.env.REACT_APP_DESK_CAMERA_MOBILE]) && trackedObjects && ( <Desk trackedObjects={trackedObjects} />)}
                  {(activeCamera === cameras[process.env.REACT_APP_DEGREE_CAMERA] || activeCamera === cameras[process.env.REACT_APP_DEGREE_CAMERA_MOBILE]) && trackedObjects && ( <Degrees trackedObjects={trackedObjects} /> )}
                  {(activeCamera === cameras[process.env.REACT_APP_SKILL_CAMERA] || activeCamera === cameras[process.env.REACT_APP_SKILL_CAMERA_MOBILE]) && trackedObjects && (<SkillDisplay trackedObjects={trackedObjects} />)}
                  {(activeCamera === cameras[process.env.REACT_APP_VINYL_CAMERA] || activeCamera === cameras[process.env.REACT_APP_VINYL_CAMERA_MOBILE]) && trackedObjects && ( <Vinyl trackedObjects={trackedObjects} /> )}
                  <FloatButton.Group >
                    <FloatButton icon={<PictureFilled />} tooltip={<div>Switch to Images</div>} onClick={() => handleRenderClick()} />
                    <FloatButton icon={<HomeFilled />} tooltip={<div>Main Camera</div>} onClick={() => setActiveCamera(cameras[process.env.REACT_APP_MAIN_CAMERA])} />
                  </FloatButton.Group>
                </>
              ) : <Loader onOk={() => setRenderScene(false)} />}
            </div>
          ) : (
            <>
              { isMobile ? (
                <StaticMobileScene scene={scene} setScene={setScene} isFirstLoad={isFirstLoad} />
              ) : (
                <StaticScene scene={scene} setScene={setScene} isFirstLoad={isFirstLoad} />
              )}
              <FloatButton.Group >
                <FloatButton icon={<VideoCameraFilled />} tooltip={<div>Switch to 3D Camera</div>} onClick={() => handleRenderClick()} />
                <FloatButton icon={<HomeFilled />} tooltip={<div>Main Camera</div>} onClick={() => setScene('main')} />
              </FloatButton.Group>
            </>
          )}
        </>
      )}
    </>
  );
}

export default App;